import { AbsoluteFill, Easing, interpolate, useCurrentFrame } from 'remotion';

// Constants
import { CLAMP_BOTH } from '@/constants/animations';
import { TYPING_TEXT_ANIMATION, WAVE_ANIMATION } from './constants';

// Components
import { BubblesAnimation } from './components/BubblesAnimation';
import { PhotoFlashAnimation } from './components/PhotoFlashAnimation';
import { TreeAnimation } from './components/TreeAnimation';
import { TypingTextAnimation } from './components/TypingTextAnimation';
import { WaveBandsAnimation } from './components/WaveBandsAnimation';

export const Scene5 = () => {
  const frame = useCurrentFrame();

  // Slides in from above, ease-out cubic for natural deceleration
  const slideInOffset = interpolate(
    frame,
    [0, WAVE_ANIMATION.duration],
    [WAVE_ANIMATION.startTop, WAVE_ANIMATION.endTop],
    { ...CLAMP_BOTH, easing: Easing.out(Easing.cubic) },
  );

  return (
    <AbsoluteFill className="overflow-hidden bg-main-gradient">
      <BubblesAnimation slideInOffset={slideInOffset} />

      {/* Camera drop, flash, and flower jump/spin */}
      <PhotoFlashAnimation />

      {/* Tree on the dark area, independent of the wave */}
      <TreeAnimation />

      {/* Decorative wave bands scrolling in opposite directions */}
      <WaveBandsAnimation />

      {/* Typewriter text overlay */}
      <TypingTextAnimation
        normalText={TYPING_TEXT_ANIMATION.normalText}
        highlightText={TYPING_TEXT_ANIMATION.highlightText}
      />
    </AbsoluteFill>
  );
};
